module.exports = __webpack_public_path__ + "Roboto-300.16a9467557c38b4e1b19.woff2";


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src634836211/src/src/assets/fonts/roboto/fonts/Roboto-300/Roboto-300.woff2
// module id = ../../../../../src/assets/fonts/roboto/fonts/Roboto-300/Roboto-300.woff2
// module chunks = main styles